import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  rating: number;
  views?: number;
  tags?: string[];
  isFirst?: boolean;
}

export default function ComicCard({ id, title, author, coverImage, category, rating, views, tags, isFirst }: ComicCardProps) {
  const formattedViews = views ? (views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views.toLocaleString()) : null;

  return (
    <Link
      to={`/comic/${id}`}
      className="group block cursor-pointer"
      data-product-shop=""
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={coverImage}
          alt={title}
          title={`${title} - 韩漫免费漫画在线观看下拉式`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 bg-primary-500 text-white text-xs rounded-md whitespace-nowrap">
            {category}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 bg-background-50/90 text-foreground-900 text-xs rounded-md font-medium whitespace-nowrap">
            {rating}
          </span>
        </div>
      </div>

      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
        {title}
      </h3>

      <p className="text-xs text-foreground-500 mb-2">{author}</p>

      {tags && tags.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-1.5 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      )}

      <div className="flex items-center justify-between">
        {formattedViews && (
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-eye-line text-xs"></i>
            </div>
            {formattedViews}
          </span>
        )}
        <span
          className={`px-4 py-1.5 rounded-full text-xs font-medium transition-colors whitespace-nowrap cursor-pointer ${
            isFirst
              ? 'bg-primary-500 text-white'
              : 'border border-foreground-300 text-foreground-600 hover:border-primary-400 hover:text-primary-600'
          }`}
        >
          开始阅读
        </span>
      </div>
    </Link>
  );
}